module.exports = __webpack_public_path__ + "img/gys_27@2x.7d4695c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_27@2x.png
// module id = xnIF
// module chunks = 0